<!--
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-08-08 16:31:21
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-10 15:17:12
 * @FilePath: \fe-frame-page\src\views\enterpriseHighNewN\components\notFullModel.vue
 * @Description: 未满一年弹窗
-->
<template>
  <a-modal
    v-model="visible"
    title="温馨提示"
    :footer="null"
    class="not-full-model"
    width="460px"
    @cancel="handleCancel"
  >
    <img class="img" src="@/assets/images/noData.png" />
    <div class="desc">企业成立时间不足一年，不符合认定条件。</div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    visible: Boolean,
  },

  methods: {
    handleCancel() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="less" scoped>
.not-full-model {
  text-align: center;
  .img {
    width: 152px;
    height: auto;
  }
  .desc {
    margin-top: -14px;
    padding-bottom: 20px;
    font-size: 14px;
    color: #333333;
  }
}
</style>